// src/slices/analysisResultSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../api/http'; // central axios (runtime baseURL + token)

// Fetch analysis result using applicationId
export const fetchAnalysisResult = createAsyncThunk(
  'analysisResult/fetchAnalysisResult',
  async (applicationId, { rejectWithValue }) => {
    try {
      const { data } = await http.get(`/analysisresult/${applicationId}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const analysisResultSlice = createSlice({
  name: 'analysisResult',
  initialState: { data: null, loading: false, error: null },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalysisResult.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAnalysisResult.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAnalysisResult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default analysisResultSlice.reducer;
